<template>
  <main id="main">
    <div class="header_page justify-content-between">
      <img src="@/assets/imgs/share.svg" class="icon-size-3 cursor-pointer" alt="" @click="shareContent('post', post.caption)">
      <div class="d-flex align-items-center">
        <p id="title_header_page">{{ t('posts') }}</p>
        <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
      </div>
    </div>
    <div v-if="loading" class="text-center mt-5">
      <p>{{ t('loading') }}</p>
    </div>
    <div v-else-if="!post.id" class="text-center mt-5">
      <p>{{ t('empty_list') }}</p>
    </div>
    <div v-else class="p-3">
      <div class="bg_white rounded-5 p-3 shadow">
        <img style="height: 30rem; object-fit: cover;" :src="post.pic" class="rounded-5 w-100 shadow mb-5" alt="" @error="$event.target.src = require('@/assets/imgs/NoPath - Copy (5).png')">
        <div class="bg_box_light_theme shadow-sm p-3 d-flex justify-content-between align-items-center rounded-4 mb-4">
          <div class="d-flex align-items-center gap-3">
            <img src="@/assets/imgs/clock.svg" class="icon-size-2" alt="">
            <p class="font_small">{{ post.created_at_local }}</p>
          </div>
          <div class="d-flex align-items-center gap-3">
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              class="icon-size-2 cursor-pointer"
              @click="toggleBookmark"
            >
              <path 
                d="M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3Z" 
                :fill="post.marked ? '#4A00E0' : 'white'"
                stroke="#4A00E0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div class="d-flex align-items-center gap-1">
              <img 
                :src="post.liked ? require('@/assets/imgs/heart-filled.svg') : require('@/assets/imgs/heart.svg')" 
                class="icon-size-2 cursor-pointer" 
                alt=""
                @error="$event.target.src = require('@/assets/imgs/heart.svg')"
                @click="toggleLike"
              >
              <p class="font_normal">{{ post.likes }}</p>
            </div>
          </div>
        </div>
        <p class="font_normal mb-3" style="white-space: pre-wrap;">{{ post.caption }}</p>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'TeacherPostsView',
  data() {
    return {
      post: {},
      loading: false,
      postId: null
    }
  },
  mounted() {
    this.postId = this.$route.params.id
    if (this.postId) {
      this.fetchPostDetails()
    }
  },
  methods: {
    async fetchPostDetails() {
      this.loading = true
      try {
        const userId = localStorage.getItem('user_id')
        const formData = createFormData({
          user_id: userId,
          id: this.postId
        })
        const response = await apiClient.post('/posts_details', formData)
        if (response.data.status === 'ok' && response.data.data) {
          this.post = response.data.data
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async toggleBookmark() {
      try {
        const userId = localStorage.getItem('user_id')
        const formData = createFormData({
          user_id: userId,
          id: this.postId
        })
        const response = await apiClient.post('/mark_post', formData)
        if (response.data.status === 'ok') {
          this.post.marked = !this.post.marked
        }
      } catch (error) {
        console.error(error)
      }
    },
    async toggleLike() {
      try {
        const userId = localStorage.getItem('user_id')
        const formData = createFormData({
          user_id: userId,
          id: this.postId
        })
        const response = await apiClient.post('/like_post', formData)
        if (response.data.status === 'ok') {
          if (this.post.liked) {
            this.post.likes--
          } else {
            this.post.likes++
          }
          this.post.liked = !this.post.liked
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>